import { render, staticRenderFns } from "./ListaNinos.vue?vue&type=template&id=1fbd5b7c&scoped=true"
import script from "./ListaNinos.vue?vue&type=script&lang=js"
export * from "./ListaNinos.vue?vue&type=script&lang=js"
import style0 from "./ListaNinos.vue?vue&type=style&index=0&id=1fbd5b7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbd5b7c",
  null
  
)

export default component.exports